<script lang="ts">
  import { navigate } from '../lib/router.svelte';
  import { login, getToken, ApiError } from '../lib/admin';

  let email = $state('');
  let password = $state('');
  let busy = $state(false);
  let error = $state<string | null>(null);
  // Notice set by handle401 when a session expires mid-use (read once).
  let notice = $state<string | null>(null);

  // Already signed in → straight to the dashboard.
  if (getToken()) {
    navigate('/admin');
  } else {
    try {
      const n = sessionStorage.getItem('sg_admin_notice');
      if (n) {
        notice = n;
        sessionStorage.removeItem('sg_admin_notice');
      }
    } catch {
      /* ignore */
    }
  }

  async function onSubmit(e: SubmitEvent): Promise<void> {
    e.preventDefault();
    if (busy) return;
    busy = true;
    error = null;
    try {
      await login(email.trim(), password);
      navigate('/admin');
    } catch (err: unknown) {
      error =
        err instanceof ApiError && err.status === 401
          ? 'That email and password don’t match.'
          : err instanceof Error
            ? err.message
            : 'Sign in failed.';
    } finally {
      busy = false;
    }
  }
</script>

<div class="console-glow flex min-h-screen items-center justify-center px-6">
  <div class="w-full max-w-sm">
    <div class="mb-8 text-center">
      <img src="/icon-128.png" alt="" class="mx-auto mb-4 h-11 w-11 rounded-xl" />
      <div class="eyebrow mb-2">Operator access</div>
      <h1 class="font-display text-2xl font-bold tracking-tight">Sideguide Admin</h1>
    </div>

    <div class="rounded-box border hair bg-base-200/60 p-6 shadow-2xl shadow-black/40">
      {#if notice}
        <div class="mb-4 rounded-field border border-warning/30 bg-warning/10 px-3 py-2 text-sm text-warning">
          {notice}
        </div>
      {/if}
      <form class="flex flex-col gap-4" onsubmit={onSubmit}>
        <label class="block">
          <span class="eyebrow mb-1.5 block">Email</span>
          <input
            type="email"
            class="input input-bordered w-full bg-base-100/60 font-mono text-sm"
            bind:value={email}
            autocomplete="username"
            placeholder="you@example.com"
            required
          />
        </label>
        <label class="block">
          <span class="eyebrow mb-1.5 block">Password</span>
          <input
            type="password"
            class="input input-bordered w-full bg-base-100/60 font-mono text-sm"
            bind:value={password}
            autocomplete="current-password"
            placeholder="••••••••"
            required
          />
        </label>

        {#if error}
          <div class="rounded-field border border-error/30 bg-error/10 px-3 py-2 text-sm text-error">
            {error}
          </div>
        {/if}

        <button type="submit" class="btn btn-primary mt-1 gap-2 font-semibold" disabled={busy}>
          {#if busy}<span class="loading loading-spinner loading-sm"></span>{/if}
          Sign in
        </button>
      </form>
      <div class="mt-4 text-center">
        <button type="button" class="eyebrow link" onclick={() => navigate('/forgot-password')}>
          Forgot your password?
        </button>
      </div>
    </div>

    <p class="eyebrow mt-5 text-center">Sideguide · content control</p>
  </div>
</div>
